import { useEffect, useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';

import { DataContext } from 'providers/data';
import { itemProduct, NR_COMPARACAO_TROCA, ParamsPageWebView } from 'utils/typeServices';

import { Typography, Box, Checkbox } from '@mui/material';

import Modals from 'components/views/Modals';
import SliderCard from 'components/views/SliderCard';
import ParseWebView from 'components/views/ParseWebView';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';
import PageErrorPendingTicket from 'components/views/ExchangeCenter/PageErrorPendingTicket';

export const LinkExtermal = styled('a')(`
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);

const Container = styled('div')(
    ({ theme }) => `
        text-align: center;
        align-items: center;
        justify-content: center;

        overflow: hidden;
        padding: 0 0 6.3rem 1.125rem;

        .content-title {
            display: none;
        }

        @media(max-width: ${theme.breakpoints.values.sm}px) {
            section:last-child {
                padding-right: 1.125rem;
            }
        }

        @media(min-width: ${theme.breakpoints.values.md}px) {
            padding: 2.5rem 0 8.43rem 0;

            .content-title {
                display: block;
            }
        }
`)

const Plans = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { dataQuoteListservices, dataValidateChoose, sucessChangeSolicitationPlatform, dataErrorTicketOpen, isPendingTicket, customerCars, selectedCar, handleErrorTicketOpen, handlePostFinancialPending } = useContext(DataContext);

    const [isOne, setIsOne] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [showModalSuccessPlatform, setShowModalSuccessPlatform] = useState(false);
    const [showModalIncompatibleExchange, setShowModalIncompatibleExchange] = useState(false);
    const [isCheckedIncompatibleExchange, setIsCheckedIncompatibleExchange] = useState(false);
    const [itemsQuotatioSafe, setItemsQuotatioSafe] = useState<Array<itemProduct>>([]);
    const [itemsQuotatioSafeEv, setItemsQuotatioSafeEv] = useState<Array<itemProduct>>([]);
    const [itemsQuotatioTracker, setItemsQuotatioTracker] = useState<Array<itemProduct>>([]);
    const [itemsQuotatioSafeLight, setitemsQuotatioSafeLight] = useState<Array<itemProduct>>([]);

    useEffect(() => {
        if (dataQuoteListservices && (itemsQuotatioSafe.length === 0 && itemsQuotatioTracker.length === 0)) {
            let arraySafe: Array<itemProduct> = [];
            let arraySafeEv: Array<itemProduct> = [];
            let arrayTracker: Array<itemProduct> = [];
            let arraySafeLight: Array<itemProduct> = [];

            const produtO_ATUALSelected = dataQuoteListservices.cotacaO_ITEMS.find(({ produtO_ATUAL, nR_TIPO_PRODUTO }) => ((nR_TIPO_PRODUTO === 12) || (nR_TIPO_PRODUTO === 11)) && produtO_ATUAL);

            dataQuoteListservices.cotacaO_ITEMS.forEach(({ nR_TIPO_PRODUTO, cD_PRODUTO, produtO_ATUAL, fL_ICS_LIGHT }, index) => {
                if ((nR_TIPO_PRODUTO === 12) && (cD_PRODUTO !== 2375) && !produtO_ATUAL) {
                    if ([2692, 2693, 2694, 2695, 2696, 3459, 3460].indexOf(cD_PRODUTO) >= 0) {
                        arraySafeEv.push(dataQuoteListservices.cotacaO_ITEMS[index]);
                    } else if (([2940, 2942, 2944, 2946].indexOf(cD_PRODUTO) >= 0) || fL_ICS_LIGHT) {
                        arraySafeLight.push(dataQuoteListservices.cotacaO_ITEMS[index]);
                        if ([2940, 2942].indexOf(cD_PRODUTO) >= 0) {
                            setIsOne(true);
                        }
                    } else {
                        arraySafe.push(dataQuoteListservices.cotacaO_ITEMS[index]);
                    }
                } else if (((nR_TIPO_PRODUTO === 11) || (cD_PRODUTO === 2375)) && !produtO_ATUAL) {
                    arrayTracker.push(dataQuoteListservices.cotacaO_ITEMS[index]);
                }
            });

            const arraySortSafe = arraySafe?.sort((a, b) => parseFloat(a.vL_TOTAL?.split(' ')[1]?.replace(',', '.')) - parseFloat(b.vL_TOTAL?.split(' ')[1]?.replace(',', '.')));
            const arraySortTracker = arrayTracker?.sort((a, b) => parseFloat(a.vL_TOTAL?.split(' ')[1]?.replace(',', '.')) - parseFloat(b.vL_TOTAL?.split(' ')[1]?.replace(',', '.')));
            const arraySortSafeLight = arraySafeLight?.sort((a, b) => parseFloat(a.vL_TOTAL?.split(' ')[1]?.replace(',', '.')) - parseFloat(b.vL_TOTAL?.split(' ')[1]?.replace(',', '.')));
            const arraySortSafeEv = arraySafeEv.sort((a, b) => parseFloat(a.vL_TOTAL?.split(' ')[1]?.replace(',', '.')) - parseFloat(b.vL_TOTAL?.split(' ')[1]?.replace(',', '.')));

            if (arraySortSafeEv.length) {
                setItemsQuotatioSafeEv(arraySortSafeEv);
            }

            if (produtO_ATUALSelected?.nR_TIPO_PRODUTO === 12) {
                setItemsQuotatioSafe([produtO_ATUALSelected, ...arraySortSafe]);
            } else {
                setItemsQuotatioSafe(arraySortSafe);
            }

            if (produtO_ATUALSelected?.nR_TIPO_PRODUTO === 11) {
                setItemsQuotatioTracker([produtO_ATUALSelected, ...arraySortTracker]);
            } else {
                setItemsQuotatioTracker(arraySortTracker);
            }

            if (arraySortSafeLight.length > 0) {
                setitemsQuotatioSafeLight(arraySortSafeLight);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataQuoteListservices]);

    useEffect(() => {
        if (dataValidateChoose?.success === false) {
            setShowModalError(true);
        } else if (dataValidateChoose?.data?.nR_COMPARACAO_TROCA === NR_COMPARACAO_TROCA.Incompativel) {
            setShowModalIncompatibleExchange(true)
        }
    }, [dataValidateChoose]);

    useEffect(() => {
        if (selectedCar && ((typeof isPendingTicket === "undefined") || (customerCars?.length > 1))) {
            handlePostFinancialPending({
                token: localStorage.getItem('token')!,
                body: {
                    CPF_CNPJ: selectedCar.NR_CNPJ_CPF,
                    ID_MOTIVO: 0,
                    DS_PLACA: selectedCar.PLACA || null,
                    CD_PARCEIRO: 1783625,
                    FL_PAGAS: true
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPendingTicket, customerCars, selectedCar]);

    useEffect(() => {
        if (sucessChangeSolicitationPlatform === true) {
            setShowModalSuccessPlatform(true);
        } else if (sucessChangeSolicitationPlatform === false) {
            setShowModalError(true);
        }
    }, [sucessChangeSolicitationPlatform]);

    return (
        <ParseWebView stepActive={1} isWebView={isWebView} typePage='quotation'>
            {dataErrorTicketOpen ?
                <PageErrorPendingTicket isWebView={isWebView} handleErrorTicketOpen={handleErrorTicketOpen} />
                :
                <Container>
                    <Typography sx={{ fontSize: '1.25rem', paddingBottom: '1.25rem', textAlign: 'center', maxWidth: { xs: '300px', md: '100%' }, margin: '0 auto' }}>
                        De acordo com <strong>o seu perfil</strong> estes são os outros planos oferecidos:
                    </Typography>
                    {dataQuoteListservices && itemsQuotatioSafe?.length > 0 &&
                        <SliderCard
                            title='RASTREADOR + SEGURO AMPLIADO'
                            subTitle='Coberturas e Serviços'
                            product='seguro'
                            listThePlan={itemsQuotatioSafe}
                            cdQuotation={dataQuoteListservices?.cD_COTACAO}
                            isWebView={isWebView}
                        />
                    }

                    {dataQuoteListservices && itemsQuotatioSafeEv?.length > 0 &&
                        <SliderCard
                            title='RASTREADOR + SEGURO AMPLIADO'
                            subTitle='Coberturas e Serviços'
                            product='seguro'
                            isEv
                            listThePlan={itemsQuotatioSafeEv}
                            cdQuotation={dataQuoteListservices?.cD_COTACAO}
                            isWebView={isWebView}
                        />
                    }

                    {dataQuoteListservices && itemsQuotatioSafeLight?.length > 0 &&
                        <SliderCard
                            title='RASTREADOR + SEGURO ESSENCIAL'
                            subTitle='Coberturas e Serviços'
                            product='seguro'
                            isOne={isOne}
                            isLight
                            isTracker
                            isWebView={isWebView}
                            listThePlan={itemsQuotatioSafeLight}
                            cdQuotation={dataQuoteListservices?.cD_COTACAO}
                        />
                    }

                    {dataQuoteListservices && itemsQuotatioTracker?.length > 0 &&
                        <SliderCard
                            title='RASTREADORES ITURAN'
                            subTitle='Coberturas e Serviços'
                            product='rastreador'
                            isTracker
                            listThePlan={itemsQuotatioTracker}
                            cdQuotation={dataQuoteListservices?.cD_COTACAO}
                            isWebView={isWebView}
                        />
                    }

                    <Modals open={showModalError}>
                        <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '24rem' } }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='.9325rem 1.43rem'>
                                <Typography fontSize='1.5625rem' fontWeight={700}>
                                    AVISO!
                                </Typography>
                                <Typography fontSize='.875rem' lineHeight='17px' paddingTop='1rem'>
                                    No momento, não conseguimos concluir sua solicitação de
                                    troca de serviço. <br />
                                    Por favor, entre em contato com a nossa <strong>central de atendimento </strong>
                                    para mais informações.
                                </Typography>
                            </Box>

                            <Box sx={{
                                borderRadius: '0 0 8px 8px',
                                padding: '1.25rem 3.81rem 2rem',
                                backgroundColor: 'primary.main',
                                'button': {
                                    width: '100%',
                                    height: '2.5rem',
                                }
                            }}>
                                <Typography fontSize='.75rem' color='white' paddingBottom='.5rem'>
                                    Digite a opção 9
                                </Typography>
                                {isWebView ?
                                    <Typography fontSize='.92rem' color='white' textAlign='center'>
                                        Fale Conosco - <b>(11) 3616-9000</b>
                                    </Typography>
                                    :
                                    <ButtonRectangle name='WHATSAPP' onClick={() => window.open('https://api.whatsapp.com/send/?phone=551136169000', '_target')}><LocalPhoneOutlinedIcon sx={{ position: 'absolute', right: '20px' }} /></ButtonRectangle>
                                }
                                <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                                    <ButtonOutlined name='CANCELAR' onClick={() => setShowModalError(false)} />
                                </Box>
                            </Box>
                        </Box>
                    </Modals>

                    <Modals open={showModalIncompatibleExchange}>
                        <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25.6rem' } }}>
                            <Box sx={{ padding: { xs: '1.78rem .9rem .59rem', md: '1.78rem 1.71rem 1.59rem' } }}>
                                <Typography fontSize='1.25rem' paddingBottom='1rem' fontWeight='700'>
                                    AVISO!
                                </Typography>
                                <Typography fontSize='1rem' lineHeight='1.27'>
                                    O serviço selecionado não é compatível com o equipamento atual. <br />
                                    Para que o novo serviço funcione corretamente, será necessário <b>agendar uma vistoria</b>.
                                </Typography>

                                <Box sx={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center', gap: '.2rem', backgroundColor: 'rgb(233, 236, 241)', margin: '1rem 0 0 0' }}>
                                    <Checkbox checked={isCheckedIncompatibleExchange} sx={{ padding: '0 0.3rem 0.3rem 0.6rem' }} onClick={() => setIsCheckedIncompatibleExchange(!isCheckedIncompatibleExchange)} />
                                    <Typography fontSize='1rem' fontWeight={500} sx={{ padding: '0.5rem 0.7rem 0.5rem 0.5rem', }}>
                                        Estou ciente e desejo continuar
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ borderRadius: '0 0 8px 8px', backgroundColor: 'primary.main', padding: { xs: '2.17rem 2.6rem 2.5rem', md: '2.17rem 4.21rem 2.57rem' }, 'button': { width: '100%', margin: '0 0 0.7rem 0' } }}>
                                <ButtonRectangle
                                    name='CONTINUAR'
                                     disabled={!isCheckedIncompatibleExchange}
                                    onClick={() => { setShowModalIncompatibleExchange(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas/troca-de-servico/servicos-adicionais`); }}
                                />

                                <ButtonOutlined
                                    name='FECHAR'
                                    isWhiteOutline={true}
                                    onClick={() => setShowModalIncompatibleExchange(false)}
                                />
                            </Box>
                        </Box>
                    </Modals>

                    <Modals open={showModalSuccessPlatform}>
                        <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23rem' } }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1.375rem 1.25rem'>
                                <Typography fontSize='1.5625rem' fontWeight={700} textAlign='center'>
                                    SOLICITAÇÃO ENVIADA!
                                </Typography>
                                <Typography fontSize='1rem' lineHeight={1.3} paddingTop='.81rem' textAlign='center'>
                                    Entre em contato com a nossa <br />
                                    equipe através do número <br />
                                    de WhatsApp abaixo. <br />
                                </Typography>
                                <Typography fontSize='1rem' lineHeight={1.3} paddingTop='.3rem' textAlign='center'>
                                    Estamos prontos para <b>atendê-lo!</b>
                                </Typography>
                            </Box>

                            <Box sx={{
                                borderRadius: '0 0 8px 8px',
                                padding: '1.25rem 3.81rem 2rem',
                                backgroundColor: 'primary.main',
                                'button': {
                                    width: '100%',
                                    height: '2.5rem',
                                }
                            }}>
                                <Box>
                                    <Typography fontSize='.75rem' color='white' paddingBottom='.5rem' textAlign='center'>
                                        Opção: <b>Trocas</b>
                                    </Typography>
                                    
                                    {isWebView ?
                                        <Typography fontSize='.92rem' color='white' textAlign='center'>
                                            Fale Conosco - <b>(11) 3616-9000</b>
                                        </Typography>
                                    :
                                        <ButtonRectangle name='WHATSAPP' onClick={() => window.open('https://api.whatsapp.com/send/?phone=551136169000', '_target')}><LocalPhoneOutlinedIcon sx={{ position: 'absolute', right: '20px' }} /></ButtonRectangle>
                                    }

                                    <Box sx={{
                                        'button': {
                                            marginTop: '1rem',
                                            borderColor: 'white',
                                            color: 'white',
                                            '&:hover': {
                                                borderColor: 'white',
                                                opacity: '.8'
                                            }
                                        }
                                    }}>
                                        <ButtonOutlined name='FINALIZAR' onClick={() => { navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`); setShowModalSuccessPlatform(false); }} />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Modals>
                </Container>
            }
        </ParseWebView>
    );
}

export default Plans;